var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-page',[_vm._v("Shows")]),_c('loading',{attrs:{"loading":_vm.showsLoading}},[_c('v-container',_vm._l((_vm.shows),function(show){return _c('dog-show',{key:show.id,staticClass:"mb-4",attrs:{"show":show}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }